module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/howto1-3c6177755fd124c22022d3aeccb464b0.png";